import { Page } from "~/v2/components/Page";
import type { CoinTransfersControllerReturn } from "./CoinTransfers.controller";
import { CryptoAgreementAccountSetupModal } from "./CryptoAgreementAccountSetupModal";
import { LegacyAddWhitelistAddressModal } from "./legacyAddWhitelistAddress/LegacyAddWhitelistAddressModal";
import { TransferCard } from "./TransferCard";
import { TransfersTable } from "./TransfersTable/TransfersTable.connector";
import { WhitelistTable } from "./WhitelistTable/WhitelistTable.connector";

export interface CoinTransfersPresProps extends CoinTransfersControllerReturn {}

export const CoinTransfersPresentation = ({
  account,
  accountId,
  product,
  isLoading,
  isFetchingEnabled,
  agreement,
  legacyAddWhitelistAddress,
  isTRCEnabled,
  onAddWhitelistAddressClicked,
}: CoinTransfersPresProps) => {
  return (
    <Page title="Crypto Transfers" className="pt-2 pb-20 sm:pb-4">
      <div className="flex w-full flex-col gap-6 md:grid md:grid-cols-[auto_357px] md:grid-rows-[auto_auto]">
        <div className="flex flex-col gap-4">
          <TransfersTable
            accountId={accountId}
            isLoading={isLoading}
            isFetchingEnabled={isFetchingEnabled}
          />
          <WhitelistTable
            accountId={accountId}
            isLoading={isLoading}
            isFetchingEnabled={isFetchingEnabled}
            isTRCEnabled={isTRCEnabled}
            onAddWhitelistAddressClicked={onAddWhitelistAddressClicked}
          />
        </div>
        <section className="w-full">
          <TransferCard
            account={account}
            accountId={accountId}
            product={product}
            isFetchingEnabled={isFetchingEnabled}
            onAddWhitelistAddressClicked={onAddWhitelistAddressClicked}
          />
        </section>
      </div>

      <CryptoAgreementAccountSetupModal
        isOpen={agreement.isModalOpen}
        onClose={agreement.onCancelAgreementModal}
        isLoading={agreement.isLoading}
        isSettingUpAccount={agreement.isSettingUpAccount}
        onSignAgreement={agreement.onSignAgreement}
        agreementUrl={agreement.agreementUrl}
      />
      <LegacyAddWhitelistAddressModal {...legacyAddWhitelistAddress} />
    </Page>
  );
};
